import {Component} from '@angular/core';

@Component({
  selector: 'app-star-icon',
  styles: `
    :host {
      height: 24px;
      width: 24px;
      display: inline-block;
      line-height: 0;
    }
  `,
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M11.6364 3.34882C11.6787 3.24566 11.7507 3.1574 11.8433 3.09528C11.9359 3.03317 12.0449 3 12.1564 3C12.2679 3 12.3769 3.03317 12.4695 3.09528C12.5621 3.1574 12.6341 3.24566 12.6764 3.34882L14.8014 8.45982C14.8412 8.55546 14.9066 8.63827 14.9904 8.69914C15.0742 8.76001 15.1732 8.79658 15.2764 8.80482L20.7944 9.24682C21.2934 9.28682 21.4954 9.90982 21.1154 10.2348L16.9114 13.8368C16.8329 13.904 16.7743 13.9915 16.7422 14.0898C16.7101 14.188 16.7057 14.2932 16.7294 14.3938L18.0144 19.7788C18.0402 19.8869 18.0335 20.0001 17.995 20.1043C17.9565 20.2085 17.8879 20.299 17.798 20.3642C17.7082 20.4295 17.601 20.4667 17.49 20.4711C17.379 20.4754 17.2692 20.4468 17.1744 20.3888L12.4494 17.5038C12.3612 17.4499 12.2598 17.4214 12.1564 17.4214C12.053 17.4214 11.9516 17.4499 11.8634 17.5038L7.13841 20.3898C7.04367 20.4478 6.93387 20.4764 6.82287 20.4721C6.71187 20.4677 6.60466 20.4305 6.51478 20.3652C6.4249 20.3 6.35638 20.2095 6.31787 20.1053C6.27936 20.0011 6.27259 19.8879 6.29841 19.7798L7.58341 14.3938C7.60725 14.2932 7.60286 14.188 7.57075 14.0897C7.53864 13.9915 7.48005 13.9039 7.40141 13.8368L3.19741 10.2348C3.11276 10.1627 3.05142 10.067 3.02117 9.95994C2.99093 9.85289 2.99313 9.73927 3.0275 9.63347C3.06188 9.52768 3.12687 9.43446 3.21427 9.36563C3.30166 9.2968 3.40751 9.25545 3.51841 9.24682L9.03641 8.80482C9.13966 8.79658 9.23864 8.76001 9.32244 8.69914C9.40625 8.63827 9.47164 8.55546 9.51141 8.45982L11.6364 3.34882Z"
        stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `,
  standalone: true
})

export class StarIconComponent {

}
